<template>

	<section>
		<!-- Clinic Search -->
		<section class="clinic-search search-bg">
			<div class="row">

				<form class="search clinic-search__form large-collapse clear_fix">

					<div class="columns small-12 medium-12 large-4 large-offset-1 search__col-margin">
						<p class="search__label-select">Введите тип или название клиники</p>
						<!-- Select -->
						<div class="search__inner select-outer">
							<select2
								:options="$parent.clinicTypes"
								placeholder="Выберите клинику"
								v-model="clinicSearchModel.clinic_type"></select2>
						</div>
						<!-- Select End -->
					</div>

					<div class="columns small-12 medium-12 large-4 search__col-margin">
						<p class="search__label-select">Выберите район или метро</p>
						<!-- Select -->
						<div class="search__inner select-outer">
							<select2
								:options="cities"
								v-model="clinicSearchModel.city"
								placeholder="Выберите район"
								disabled></select2>
						</div>
						<!-- Select End -->

						<!-- Checkboxes -->
						<div class="search__inner">
							<div class="checkbox clear_fix">

								<div class="checkbox__inner">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" value="private"
													 v-model="clinicSearchModel.own_type">
										<span class="checkbox__custom-input"></span>
										<span class="checkbox__text checkbox__text_white">Частные<br> клиники</span>
									</label>
								</div>

								<div class="checkbox__inner">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" value="state"
													 v-model="clinicSearchModel.own_type">
										<span class="checkbox__custom-input"></span>
										<span class="checkbox__text checkbox__text_white">Гос.<br> клиники</span>
									</label>
								</div>

							</div>

							<!-- Checkboxes End -->
						</div>
					</div>

					<div class="columns small-12 medium-12 large-2 end">

						<div class="search__inner search__inner_pad">
							<a @click="getClinics" class="search__btn search__btn_show search__btn_size">Показать</a>
						</div>

						<!--<div class="search__inner">
							<p class="search__info">Найдено 10324</p>
						</div>-->

					</div>
				</form>
			</div>

		</section>
		<!-- Clinic Search End -->

		<!-- Clinics -->
		<section class="clinics section_pad">
			<div class="row">

				<div class="columns small-12 medium-12 large-12">
					<h2 class="section-title">Список клиник по запросу</h2>
				</div>

				<div class="columns small-12 medium-12 large-8">
					<!-- Clinics Main Wrap -->
					<div class="clinics__main-wrap">

						<!-- Clinic Item Wrap -->
						<div class="clinics__item-wrap main-border" v-for="clinic in clinics">

							<!-- Clinic Item -->
							<div class="box flex clear_fix hr">

								<div class="box__avatar-wrap">
									<router-link :to="{name: 'SingleClinic', query: {id: clinic._id}}" class="box__link">
										<user-avatar :data="clinic" :setClass="'box__avatar_clinic-item link_black'"></user-avatar>
									</router-link>
								</div>

								<div class="box__content box__stars">
									<h4 class="box__title box__title_clinic-item underline">
										<router-link :to="{name: 'SingleClinic', query: {id: clinic._id}}" class="link_black">
											{{clinic.name}}
										</router-link>
									</h4>
									<div class="box__labels-wrap">
										<span class="box__label" v-show="clinic.clinic_type_name">{{clinic.clinic_type_name}}</span>
									</div>
									<p class="box__paragraph bold">{{clinic.own_type | type}}</p>
									<p class="box__paragraph" v-html="clinic.description"></p>

									<rating :stars="clinic.mark" :review-count="clinic.mark_count"></rating>
								</div>

							</div>
							<!-- Clinic Item End -->

							<!-- Adress Clinic -->
							<div class="box flex clear_fix hr">

								<div class="box__content adress">
									<p class="box__paragraph adress__item" v-if="clinic.city !== undefined">
										{{clinic.city.region.country.name}} {{clinic.city.region.name}}, {{clinic.city.name}}, ул. {{clinic.street}}, {{clinic.house}}
									</p>
								</div>

								<!--<div class="box__btn box__btn_wrap">
									<a href="#" class="box__btn-adress">Написать</a>
								</div>-->

							</div>
							<!-- Adress Clinic End -->

						</div>
						<!-- Clinic Item Wrap End -->

					</div>
					<!-- Clinics Main Wrap End -->

					<!-- Button -->
					<div class="basic-box__btns text_center" v-show="pagination.current < pagination.total">
						<button class="basic-box__btn btn_light-blue" @click="loadPage">
							Показать больше
							<i class="basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"></i>
						</button>
					</div>
					<!-- Button End -->

				</div>
				<!-- Column End -->

				<div class="columns small-12 medium-12 large-4">
					<div id="map" class="mapmain"><div class="temporary">Функционал карты временно недоступен</div></div>
				</div>

			</div>
			<!-- Row End -->
		</section>
		<!-- Clinics End -->
	</section>

</template>

<script>
	import Pagination from '@/components/Pagination.vue';
	import Rating from '@/components/Stars/Rating.vue';

	export default {
		name: "Clinics",
		components: { Rating, Pagination},
		mounted() {
			this.getClinics();
		},
		data() {
			return {
				clinics: [],
				cities: [],
				clinicSearchModel: {
					own_type: this.$route.query.own_type || [],
					city: this.$route.query.city || '',
					clinic_type: this.$route.query.clinic_type || '',
					per_page: 10
				},
				pagination: {
					total: null,
					current: 1
				}
			}
		},
		methods: {
			getClinics() {
				this.$store.dispatch('clinic/search', this.clinicSearchModel).then(result => {
					this.clinics = result.data

					this.pagination.total = result.last_page
					this.pagination.current = result.current_page
				})
			},
//			loadMore(page) {
//				this.pagination.current = page
//				this.getClinics()
//			},
			loadPage() {
				this.clinicSearchModel.per_page += 7;
//				this.pagination.current += 1;
				this.getClinics();
			}
		}
	}
</script>

<style scoped>
	.link_black {
		color: #333;
	}
</style>



// WEBPACK FOOTER //
// Clinics.vue?7c0a93a5